import { render, staticRenderFns } from "./user-info.vue?vue&type=template&id=1471cb04&"
import script from "./user-info.vue?vue&type=script&lang=js&"
export * from "./user-info.vue?vue&type=script&lang=js&"
import style0 from "./user-info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports